import { useState, useEffect } from 'react'
import { WifiOff } from 'lucide-react'
import { useT } from '../i18n/index.js'

/**
 * F30 — Banner hors-ligne.
 * Affiche un banner quand navigator.onLine === false.
 */
export function OfflineBanner() {
  const t = useT()
  const [offline, setOffline] = useState(!navigator.onLine)

  useEffect(() => {
    const goOffline = () => setOffline(true)
    const goOnline = () => setOffline(false)
    window.addEventListener('offline', goOffline)
    window.addEventListener('online', goOnline)
    return () => {
      window.removeEventListener('offline', goOffline)
      window.removeEventListener('online', goOnline)
    }
  }, [])

  if (!offline) return null

  return (
    <div
      className="fixed top-0 inset-x-0 z-50 flex items-center justify-center gap-2 px-4 py-2 bg-[var(--color-warning)] text-white text-sm font-medium"
      role="alert"
      aria-live="assertive"
    >
      <WifiOff size={16} />
      <span>{t.offline?.message || 'Vous etes hors ligne'}</span>
    </div>
  )
}
